import React from 'react';
import '../css/Navbar.css';
import navLogo from '../images/header-logo.png';

const Navbar: React.FC = () => {
    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container">
                <a className="navbar-brand" href="#home">
                <img src={navLogo} className="img-fluid nav-logo" alt="NavLogo" />
                </a>

                <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarNav" 
                    aria-controls="navbarNav" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page" href="#about">About Me</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#myWork">Projects</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#creative">Creative Work</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://stephjeter.com/documents/Stephanie_Jeter_Resume.pdf" target='_blank' rel="noreferrer">CV</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="mailto:steph@stephjeter.com">Contact Me</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
